import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext';
import '../css/DashboardPage.css';

const DashboardPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);

  // Styles for the toolbar
  const styles = {
    toolbar: {
      display: "flex",
      justifyContent: "flex-start",
      padding: "10px 20px",
      backgroundColor: "#f5f5f5",
      borderBottom: "1px solid #ddd",
      gap: "10px", // Adds space between buttons
    },
    button: {
      padding: "10px 20px",
      fontSize: "16px",
      backgroundColor: "#007bff",
      color: "#fff",
      textDecoration: "none", // Removes underline from links
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
    },
  };

  // 處理登出
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // 處理 Scheduling 頁面導航
  const handleSchedulingClick = () => {
    navigate('/scheduling');
  };

  // 處理 Reports 頁面導航
  const handleReportsClick = () => {
    navigate('/reports');
  };

  // 處理 Create Appointment 頁面導航
  const handleCreateAppointmentClick = () => {
    navigate('/scheduling/create');
  };

  // 處理 Sleeping Report 頁面導航
  const handleSleepingReportClick = () => {
    navigate('/sleeping-report');
  };

  // 處理 Admin 頁面導航
  const handleAdminClick = () => {
    navigate('/admin');
  };

  // 處理 Admin Schedules 頁面導航
  const handleAdminSchedulesClick = () => {
    navigate('/admin/schedules');
  };

  // 處理 Admin Check-In 頁面導航
  const handleAdminCheckInClick = () => {
    navigate('/admin/checkIn');
  };

  // 處理 Ambassador Check-In 頁面導航
  const handleAmbassadorCheckInClick = () => {
    navigate('/ambassador/checkIn');
  };

  const handleBigScreenAdminClick = () => {
    navigate('/bsa');
  };

  const handleNewAdminSchedulesClick = () => {
    navigate('/test/admin/schedules');
  };

  return (
    <div>
      {/* Top Toolbar with Links */}

      <div style={styles.toolbar}>
        <a
          href="https://www.magicofhappiness.net/ambassador/checkIn/"
          style={styles.button}
        >
          Check-In Form
        </a>
        <a
          href="https://main.d2fzi6aakzazn.amplifyapp.com/general"
          style={styles.button}
        >
          Omni Channel Page (--CI)
        </a>
        <a
          href="https://main.d2fzi6aakzazn.amplifyapp.com/public"
          style={styles.button}
        >
          Omni Channel Page (--NA)
        </a>
        <a
          href="https://main.d2fzi6aakzazn.amplifyapp.com/?serial_number=HKAP0100000001"
          style={styles.button}
        >
          Omni Channel Page (SN=001)
        </a>
      </div>
      <div className="dashboard-container">
        <div className="dashboard-content">
          <h1 className="dashboard-title">Aromapodpro Backend System by KAT LAI</h1>
          {user && <p>Welcome, {user.username}!</p>}
          <div className="dashboard-actions">
            {/* Scheduling 按鈕 */}
            {/* <button className="dashboard-button" onClick={handleSchedulingClick}>
            <i className="icon-calendar"></i>
            Scheduling
          </button> */}

            {/* Create Appointment 按鈕 */}
            {/* <button className="dashboard-button" onClick={handleCreateAppointmentClick}>
            <i className="icon-plus"></i>
            Create Appointment
          </button> */}

            {/* Reports 按鈕 */}
            {/* <button className="dashboard-button" onClick={handleReportsClick}>
            <i className="icon-chart"></i>
            Reports
          </button> */}

            {/* Sleeping Report 按鈕 */}
            {/* <button className="dashboard-button" onClick={handleSleepingReportClick}>
            <i className="icon-bed"></i>
            Sleeping Report
          </button> */}

            {/* Admin 按鈕 */}
            {user?.role === 'admin' && (
              <button className="dashboard-button" onClick={handleAdminClick}>
                <i className="icon-admin"></i>
                CHECK - Device's Schedules
              </button>
            )}

            {/* Admin Schedules 按鈕 */}
            {user?.role === 'admin' && (
              <button className="dashboard-button" onClick={handleAdminSchedulesClick}>
                <i className="icon-schedule"></i>
                SET - Device's Autoscheduling
              </button>
            )}

            {user?.role === 'admin' && (
              <button className="dashboard-button" onClick={handleNewAdminSchedulesClick}>
                <i className="icon-schedule"></i>
                NEW SET - Device's Autoscheduling [NEW]
              </button>
            )}


            {/* Admin Check-In 按鈕 */}
            {user?.role === 'admin' && (
              <button className="dashboard-button" onClick={handleAdminCheckInClick}>
                <i className="icon-check-in"></i>
                LOOKUP - Hotel Check-In Guest
              </button>
            )}

            {user?.role === 'admin' && (
              <button className="dashboard-button" onClick={handleBigScreenAdminClick}>
                <i className="icon-check-in"></i>
                LOOKUP - Device History Status + Room Specifications
              </button>
            )}

            {/* Ambassador Check-In 按鈕 */}
            {user?.role === 'ambassador' && (
              <button className="dashboard-button" onClick={handleAmbassadorCheckInClick}>
                <i className="icon-check-in"></i>
                Ambassador Check-In
              </button>
            )}

            {/* Logout 按鈕 */}
            <button className="dashboard-button logout-button" onClick={handleLogout}>
              <i className="icon-logout"></i>
              LOGOUT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;